export class WorkerResult {
  id?: string;
  timestamp: Date;
  state: WorkerState;
  data: WorkerData;

  constructor(data: any) {
    Object.assign(this, data);

    if (data?.timestamp) {
      this.timestamp = new Date(data.timestamp);
    }

    if (data.data) {
      this.data = new WorkerData(data.data);
    }
  }
}

export class WorkerData {
  progress: number;
  message: string;
  constructor(data: any) {
    Object.assign(this, data);
  }
}

export enum WorkerState {
  Created = 'Created', //Noch nichts aufgerufen
  Initializing = 'Initializing', //Process() aufgerufen
  Running = 'Running', //Die von Process() zurückgegebene Func aufgerufen
  Completing = 'Completing', //Process()-Func beendet
  Cancelled = 'Cancelled', //Cancel aufgerufen
  Faulted = 'Faulted', //Exception aufgetreten
  CompletedSuccessfully = 'CompletedSuccessfully', //Process()-Func beendet und alle Streams geschlossen
  ResultDeliveredSuccessfully = 'ResultDeliveredSuccessfully', //Result aufgerufen
}
